import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

/* views import */
import Home from './components/home'
import Header from './components/header'
import Footer from './components/footer'
import Login from './components/login'
import productList from './components/productList'
import productDiscount from './components/productDiscount'
import productFreeDelivery from './components/productFreeDelivery'
import productListSearch from './components/productListSearch'
import productDetail from './components/productDetail'
import cart from './components/cart'
import checkout from './components/checkout'
import success from './components/success'
import Reset from './components/Reset'
import ProductListByProvider from './components/ProductListByProvider'
import ProductsBySubCategory from './components/ProductsBySubCategory'
import DownloadApp from './components/DownloadApp'
import TermsAndConditions from './components/terminosYCondiciones'
import Stores from './components/stores'

/* HOC import  */
import ScrollToTop from './utils/ScrollToTop'

/* Import Context */
import ContextApp from './context/ContextApp'
import SingleStore from './components/SingleStore'

export default () => {
  return (
    <ContextApp>
      <Router>
        <ScrollToTop>
          <DownloadApp />
          <Switch>
            <body class="page home page-template-default">
              <div id="page" class="hfeed site">
                <Header />
                <Route exact path="/" component={Home} Home  />
                <Route exact path="/my_account" component={Login} />
                <Route exact path="/reset_password" component={Reset} />
                <Route
                  exact
                  path="/productos/:categoria/:id"
                  component={productList}
                />
                <Route exact path="/ofert_black" component={productDiscount} />
                <Route
                  exact
                  path="/free_delivery"
                  component={productFreeDelivery}
                />
                <Route
                  exact
                  path="/product_search"
                  component={productListSearch}
                />
                <Route
                  exact
                  path="/productos/subcategoria/:subcategoria/:id"
                  component={ProductsBySubCategory}
                />
                <Route
                  exact
                  path="/products/provider/:id"
                  component={ProductListByProvider}
                />
                <Route
                  exact
                  path="/productos/:category/:slug/:id"
                  component={productDetail}
                />
                <Route exact path="/cart" component={cart} />
                <Route exact path="/checkout" component={checkout} />
                <Route exact path="/success" component={success} />
                <Route
                  exact
                  path="/termsandconditions"
                  component={TermsAndConditions}
                />
                <Route exact path="/stores" component={Stores} />
                <Route exact path="/store/company/:slug/:id" component={SingleStore} />
                <Footer />
              </div>
            </body>
          </Switch>
        </ScrollToTop>
      </Router>
    </ContextApp>
  )
}
